import React, {useEffect, useState} from 'react';
import TextArea from "./textArea";
import style from "../task-creator.module.css";
import BtnDelSvg from "../utils/btn-del-svg";

const ExplanationAnswer = ({id,deleteHandler,change,defaultValue={text:null}}) => {
    const [text,setText]=useState(defaultValue?.text||'')
    function changeHandler(e) {
        e.target.tagName === 'TEXTAREA' && setText(e.target.value)
    }
    useEffect(()=>{
        change(text,id)
    },[text])
    return (
        <div className={style.task_line_box}>
            <TextArea changeHandler={changeHandler} defaultValue={defaultValue.text} value={text}/>
            <button className={style.task_answer_del}  onClick={e => deleteHandler(id)}><BtnDelSvg/></button>
        </div>
    );
};

export default ExplanationAnswer;